import { useStoreActions } from '~/contexts';
import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { integrationModel } from '~/models';
const EMPTY_QBO_CLASSES = [];
export const useQboClasses = function useQboClasses() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { integrations } = useIntegrations({
        enabled: false
    });
    const allowToCustomizeQboClasses = integrationModel.allowToCustomizeQboClasses(integrations);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.QboClasses
        ],
        queryFn: ()=>api.qbo.getClasses(),
        enabled: allowToCustomizeQboClasses,
        refreshOnHookMount
    });
    return {
        qboClasses: data !== null && data !== void 0 ? data : EMPTY_QBO_CLASSES,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
